// const apiEndpoint = 'http://localhost:8002/';
const apiEndpoint = 'https://exam.eic.com.vn/';
// const apiEndpoint = 'http://192.168.31.7:8002/';

export default apiEndpoint;
